import { TranslationKeys } from '~frontend-common/i18n/english/claim-subquestions.i18n';

const keys: TranslationKeys = {
  claims: {
    actions: {
      add: 'Ajouter un sinistre',
      edit: 'Modifier',
      remove: 'Supprimer',
    },
    car: {
      title: 'Ajoutez tous les accidents ou sinistres responsables et non responsables.',
    },
    home: {
      title: 'Parlez-nous de vos réclamations les plus récentes.',
    },
    fields: {
      claimDate: {
        home: 'Date de la réclamation',
        car: 'Date de la réclamation',
      },
      claimedAmount: 'Montant payé par l’assureur',
      claimDescription: 'Dites-nous ce qui s’est passé',
      responsible: {
        specificDriver: '{{0}} était-il responsable de l’accident?',
        default: 'Étiez-vous responsable de l’accident?',
      },
    },
    placeholders: {
      claimedAmount: 'ex. 4,000',
      claimDescription: {
        car: 'ex. Collision',
        home: 'ex. Inondations',
      },
    },
  },
};

export default keys;
